import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ChakraBaseProvider } from "@chakra-ui/react";//Vishy 2025-02-18 build warning "ChakraProvider" not used, so removed
import { theme } from "./Styles/Theme";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { persistor, store } from "./redux/Store";

import * as serviceWorkerRegistration from "./service-worker-registration";

// Claude: reCAPTCHA V3 provider — wraps entire app so Login and Registration pages
// can use the useGoogleReCaptcha hook to get a score-based token silently on submit. 24-03-2026
const RECAPTCHA_V3_SITE_KEY = process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY || "";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate persistor={persistor}></PersistGate>
    <ChakraBaseProvider theme={theme}>
      <BrowserRouter>
        <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_V3_SITE_KEY}>
          <App />
        </GoogleReCaptchaProvider>
      </BrowserRouter>
    </ChakraBaseProvider>
  </Provider>
  // </React.StrictMode>
);
// Claude: unregister service worker — was causing stale cache on deploy 19-04-2026
serviceWorkerRegistration.unregister();
